import { TextField } from '@sitecore-jss/sitecore-jss-nextjs';
import TextWithPnMergeTag from '../../shared/TextWithPnMergeTag/TextWithPnMergeTag';
import React from 'react';

interface IProps {
  mergeTagField: TextField;
  mergeTagObj: any;
  style?: React.CSSProperties;
  inheritLinkColor?: boolean;
}
const SuccessPageMergeTagText: React.FC<IProps> = (props) => {
  const style = props.style || {};
  const RTFromSiteCore: TextField = props.mergeTagField || { value: '' };
  const mergeTagObj = {
    ...props?.mergeTagObj,
    ...props?.mergeTagObj?.confirmedsitesData,
    ...props?.mergeTagObj?.confirmedProtocolInfo,
  };
  let newValue = '';

  if (mergeTagObj && Object.keys(mergeTagObj).length > 0) {
    // Get the mergeTags out from the RTFromSiteCore.value and store it in an array
    const originaValue: string = (RTFromSiteCore.value || '') as string;
    const mergeTagsInText: string[] = (originaValue.match(/\[(.*?)\]/g) || []).map((tag) =>
      tag.slice(1, -1)
    );

    const replaceMergeTags = (): string => {
      let replacedValue = originaValue;
      mergeTagsInText.forEach((tag) => {
        const tagValue = mergeTagObj[tag as keyof any] || '';
        replacedValue = replacedValue.replace(new RegExp(`\\[${tag}\\]`, 'g'), tagValue as string);
      });
      return replacedValue;
    };

    newValue = replaceMergeTags();
  } else {
    newValue = props.mergeTagField.value as string;
  }

  return (
    <TextWithPnMergeTag
      data-testid="merge-tag"
      style={style}
      field={{ ...RTFromSiteCore, value: newValue }}
      inheritLinkColor={props?.inheritLinkColor}
    />
  );
};

export default SuccessPageMergeTagText;
